// extracted by mini-css-extract-plugin
module.exports = {"downloadIcon":"DownloadButton_downloadIcon__2d7--","root":"DownloadButton_root__1N-s5","options":"DownloadButton_options__v1Qw6","option":"DownloadButton_option__2UUdG"};